import React, { useState } from 'react';
import * as Icon from 'react-feather';
import PagesAuthHeader from '../../feature-module/frontend/pages/authentication/common/header';
import { Link } from 'react-router-dom';
import { all_routes } from '../../core/data/routes/all_routes';
import { adminLogin } from '../../services/authServices';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd'; // Import antd Button
import { UserRoles } from '../common/constants/userRoles';
import { toast } from 'react-toastify';

const Login = () => {
  const routes = all_routes;
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      const response = await adminLogin(phoneNumber, password);
      console.log('login response: ', response);

      if (response.error) {
        console.error('Login error:', response.message);
        toast.error(response.message || 'Login failed');
      } else {
        const data = response.data;
        if (
          ![
            UserRoles.SUPER_ADMIN,
            UserRoles.ADMIN,
            UserRoles.MODERATOR,
          ].includes(data.user.role)
        ) {
          toast.error('Yetkisiz kullanıcı');
          return;
        }
        localStorage.setItem('accessToken', data.access_token);
        localStorage.setItem('refreshToken', data.refresh_token);
        localStorage.setItem('userData', JSON.stringify(data.user));
        localStorage.setItem('userRole', data.user.role);
        navigate('/');
      }
    } catch (error) {
      console.error('Login failed:', error);
      toast.error('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="content"
        style={{
          height: 'calc(100vh - 85px)',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-6 mx-auto">
              <div className="login-wrap">
                <div className="login-header">
                  <h3>Login</h3>
                  <p>Please enter your login credentials</p>
                </div>
                {/* Login Form */}
                <form action={routes.customerDashboard}>
                  <div className="log-form">
                    <div className="form-group">
                      <label className="col-form-label">Phone Number</label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="+1234567890"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        disabled={isLoading}
                      />
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col">
                          <label className="col-form-label">Password</label>
                        </div>
                        {/* <div className="col-auto">
                          <Link
                            className="forgot-link"
                            to={'/auth/password-recovery'}
                          >
                            Forgot Password
                          </Link>
                        </div> */}
                      </div>
                      <div className="pass-group">
                        <input
                          type={passwordVisible ? 'text' : 'password'}
                          className="form-control pass-input"
                          placeholder="*************"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          disabled={isLoading}
                        />
                        <span
                          className="toggle-password"
                          onClick={togglePasswordVisibility}
                        >
                          {passwordVisible ? (
                            <Icon.EyeOff className="react-feather-custom" />
                          ) : (
                            <Icon.Eye className="react-feather-custom" />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6" style={{ height: '34px' }}>
                        <label
                          className="custom_check"
                          style={{ height: '26px', alignContent: 'center' }}
                        >
                          <input
                            type="checkbox"
                            name="rememberme"
                            className="rememberme"
                            disabled={isLoading}
                          />
                          <span className="checkmark" />
                          Remember Me
                        </label>
                      </div>
                    </div>
                  </div>
                  <Button
                    type="primary"
                    className="w-100 login-btn"
                    onClick={handleLogin}
                    loading={isLoading}
                    disabled={isLoading}
                  >
                    Login
                  </Button>
                </form>
                {/* /Login Form */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
